export { default as ReviewsProductPage } from './ui/ReviewsProductPage';
